/**
 * 설비 정보 필드 상수 (클라이언트 안전)
 * type-graphql registerEnumType은 서버에서만 호출
 *
 * @see packages/shared/src/graphql/types/inputs/UpdateMachineInfo.input.ts
 */

/**
 * 설비 정보 수정 가능 필드 열거형
 * 허용된 필드만 수정 가능 (화이트리스트)
 */
export enum MachineInfoField {
  title = "title",
  position = "position",
  modelNo = "modelNo",
  modelYear = "modelYear",
  modelCreator = "modelCreator",
  checkName = "checkName",
  checkStartDate = "checkStartDate",
  checkEndDate = "checkEndDate",
}

/**
 * 허용된 설비 정보 필드 목록 (화이트리스트)
 * Resolver에서 검증에 사용
 */
export const ALLOWED_MACHINE_INFO_FIELDS = Object.values(MachineInfoField);

/**
 * 설비 정보 패치 타입 (클라이언트용)
 * type-graphql InputType은 서버에서만 사용
 */
export interface MachineInfoPatch {
  field: MachineInfoField;
  value: string;
}
